/**
 *
 * Asynchronously loads the component for TwitterShareButton
 *
 */

import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import('./index'),
  loading: () => null,
});



// WEBPACK FOOTER //
// ./src/ui/components/twitter-share-button/loadable.js